/**
 * The candidate auth guard. Signed out → bounce to /sign-in, remembering where they were headed so
 * sign-in can return them there. Signed in → render the protected route.
 *
 * The session store hydrates synchronously from localStorage (zustand persist default), so
 * `accessToken` is already correct on the first render — there is no hydration flash to guard.
 */
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useCandidateSession } from './session';

export function RequireCandidate() {
  const accessToken = useCandidateSession((state) => state.accessToken);
  const location = useLocation();

  if (accessToken === null) {
    return <Navigate to="/sign-in" replace state={{ from: location.pathname + location.search }} />;
  }
  return <Outlet />;
}
